import React from 'react';
import { MessageCircle, Lock, Zap, Layers, RefreshCw, Globe } from 'lucide-react';
export function Features() {
  return <section id="features" className="py-16 md:py-24 bg-white" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="text-center mb-16" data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-142">
            Why Choose Agentter.ai
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-143">
            Our platform makes it easy to build powerful AI agents without any
            coding knowledge.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-12" data-id="element-144">
          <div className="flex flex-col items-start" data-id="element-145">
            <div className="bg-gray-100 p-3 rounded-lg mb-4" data-id="element-146">
              <MessageCircle className="text-black" size={24} data-id="element-147" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-148">
              Natural Language Interface
            </h3>
            <p className="text-gray-600" data-id="element-149">
              Describe what you need in plain English. No coding or technical
              expertise required.
            </p>
          </div>
          <div className="flex flex-col items-start" data-id="element-150">
            <div className="bg-gray-100 p-3 rounded-lg mb-4" data-id="element-151">
              <Lock className="text-black" size={24} data-id="element-152" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-153">
              Enterprise-Grade Security
            </h3>
            <p className="text-gray-600" data-id="element-154">
              Your data stays private and secure with end-to-end encryption and
              SOC 2 compliance.
            </p>
          </div>
          <div className="flex flex-col items-start" data-id="element-155">
            <div className="bg-gray-100 p-3 rounded-lg mb-4" data-id="element-156">
              <Zap className="text-black" size={24} data-id="element-157" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-158">
              Rapid Deployment
            </h3>
            <p className="text-gray-600" data-id="element-159">
              Go from idea to working agent in minutes, not weeks or months.
            </p>
          </div>
          <div className="flex flex-col items-start" data-id="element-160">
            <div className="bg-gray-100 p-3 rounded-lg mb-4" data-id="element-161">
              <Layers className="text-black" size={24} data-id="element-162" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-163">
              Integration Ecosystem
            </h3>
            <p className="text-gray-600" data-id="element-164">
              Connect to hundreds of popular business tools and software with
              pre-built integrations.
            </p>
          </div>
          <div className="flex flex-col items-start" data-id="element-165">
            <div className="bg-gray-100 p-3 rounded-lg mb-4" data-id="element-166">
              <RefreshCw className="text-black" size={24} data-id="element-167" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-168">
              Continuous Learning
            </h3>
            <p className="text-gray-600" data-id="element-169">
              Your agents get smarter over time, adapting to your business needs
              and feedback.
            </p>
          </div>
          <div className="flex flex-col items-start" data-id="element-170">
            <div className="bg-gray-100 p-3 rounded-lg mb-4" data-id="element-171">
              <Globe className="text-black" size={24} data-id="element-172" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-173">
              Scalable Architecture
            </h3>
            <p className="text-gray-600" data-id="element-174">
              Whether you're a small business or enterprise, our platform scales
              with your needs.
            </p>
          </div>
        </div>
      </div>
    </section>;
}